import { Breakpoint } from '../lib/utils';

export const initFooterAccordions = () => {
	const els = document.querySelectorAll('.js-footer-accordion');

	for (const el of els) {
		initFooterAccordion(el);
	}
};

let iteration = 0;

/**
 * Initializes a footer accordion component.
 * @param {HTMLElement} el - Footer accordion element
 */
const initFooterAccordion = (el) => {
	const
		headerEl = el.querySelector('.js-footer-accordion-header'),
		buttonEl = el.querySelector('.js-footer-accordion-button'),
		collapseEl = el.querySelector('.js-footer-accordion-collapse');

	if (
		!headerEl
		|| !buttonEl
		|| !collapseEl
	) {
		throw new Error('Missing footer accordion elements');
	}

	if (!headerEl.textContent.trim()) {
		el.parentElement.parentElement.removeChild(el.parentElement)
		return;
	}

	// define locally to keep value for event listeners
	const i = iteration;

	let isAccordion = false;

	const check = () => {
		if (innerWidth < Breakpoint.LG) {
			if (isAccordion) {
				return;
			}

			el.id = `footerAccordion-${i}`;

			headerEl.id = `heading-${i}`;

			buttonEl.dataset.bsToggle = 'collapse';
			buttonEl.dataset.bsTarget = `#collapse-${i}`;
			buttonEl.ariaExpanded = 'true';
			buttonEl.setAttribute('aria-controls', `collapse-${i}`);
			buttonEl.classList.add('collapsed');

			collapseEl.id = `collapse-${i}`;
			collapseEl.dataset.bsParent = `footerAccordion-${i}`;
			collapseEl.setAttribute('aria-labelledby', `heading-${i}`);
			collapseEl.classList.add('collapse', 'collapsed');

			isAccordion = true;

		} else {
			if (!isAccordion) {
				return;
			}

			el.removeAttribute('id');

			headerEl.removeAttribute('id');

			buttonEl.removeAttribute('data-bs-toggle');
			buttonEl.removeAttribute('data-bs-target');
			buttonEl.removeAttribute('aria-expanded');
			buttonEl.removeAttribute('aria-controls');
			buttonEl.classList.remove('collapsed');

			collapseEl.removeAttribute('id');
			collapseEl.removeAttribute('data-bs-parent');
			collapseEl.removeAttribute('aria-labelledby');
			collapseEl.classList.remove('collapse', 'collapsed', 'show');

			isAccordion = false;
		}
	};

	check();
	addEventListener('resize', check);

	iteration++;
};
